const Quizs = (no, question, answer, candidates) => ({
  no,
  question,
  answer,
  candidates
})

export default [
  Quizs(1,
    `예수님은 골고다 언덕에서 십자가에 못 박혀 돌아가셨습니다. 여기서 ‘골고다’의 의미는 무엇일까요?`,
      2,
      ["죽음", "해골의 곳", "지옥"]
    ),
  Quizs(2,
    `다음 중 부활절의 “부”로 옳은 것은 무엇일까요?`,
    1,
    ["다시 부(復)", "뜰 부(浮)", "미쁠 부(孚)"]
  ),
  Quizs(3,
    `예수님은 3일 만에 부활하신 후 여러 사람들에게 자신의 모습을 보이셨습니다. 이때 예수님의 부활을 가장 처음 목격한 인물은 누구일까요?`,
      2,
      ["베드로", "막달라 마리아", "요한"]
    ),
    Quizs(4,
      `도마는 부활하신 예수님을 의심하며 상처 자국을 봐야 믿겠다고 했습니다. 도마가 보고자한 예수님의 상처 자국이 아닌 곳은 어디일까요?`,
      1,
      ["발", "손", "옆구리"]
    ),
  Quizs(5,
    `부활절은 영어로 ‘Easter’ 입니다. Easter의 어원은 무엇일까요?`,
    3,
    ["Eous(새벽의)", "Eurus(바람)", "Eostre(봄의 여신)"]
  ),
  Quizs(6,
    `부활 후에 예수님은 엠마오라는 마을로 가는 두 제자와 동행하십니다. 이때 두 제자 중 한명의 이름은 무엇일까요?`,
    3,
    ["맛디아", "다대오", "글로바"]
  ),
  Quizs(7,
    `지난주 종려주일에 드린 대학부 테네브레 예배에 대한 설명으로 옳은 것은 무엇일까요?`,
    2,
    ["테네브레는 영어로 tenebre이다.", "탁현수 목사님의 설교 제목은 '베드로를 보시니' 이었다. ", "남산 산책에서 받은 말씀카드는 누가복음 10장 45절이다."]
  ),
  Quizs(8,
    `부활절은 과거 325년 니케아 공의회에서 서방교회들의 기준을 따라 정해졌습니다. 이때 정해진 부활절의 기준은 무엇일까요? `,
    1,
    ["춘분 다음 보름달 이후의 첫 주일", "양력 4월의 첫 번째 주일", "음력 3월의 첫 번째 주일"]
  ),
  Quizs(9,
    `폴란드에서는 부활절 다음 월요일에 함께 ‘이것’을 하며 서로의 건강과 안전을 기원합니다. ‘이것’은 무엇일까요?`,
    3,
    ["나뭇가지 씹기", "땅에 달걀 껍질 묻기", "물 뿌리기"]
  ),
  Quizs(10,
    `Re VS 100의 진행자인 안태호 벗님은 1997년생(빠른)입니다. 그렇다면 1997년도의 부활절은 언제였을까요?`,
    1,
    ["1997년 3월 30일", "1997년 4월 7일", "1997년 4월 15일 "]
  )
];